import Grid from '@material-ui/core/Grid';
import React, { PureComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import './app.scss';
import Callback from './auth/callback';
import AppDrawer from './view/components/app-drawer/app-drawer';
import AppHeaderBar from './view/components/app-header-bar/app-header-bar';
import LogoutAuth from './view/components/logout-auth/logout-auth';
import MenuDrawer from './view/components/menu-drawer/menu-drawer';
import NotificationDrawer from './view/components/notification-drawer/notification-drawer';
import NotificationDrawerApp from './view/components/notification-drawer/notification-drawer-app';
import SnackBar from './view/components/snackbar/snackbar';
import deviceManagementPage from './view/pages/device-management/device-management-page';
import Devices from './view/pages/devices/devices';
import TeracomDevices from './view/pages/devices/teracom';
import notification from './view/pages/notification-settings-page/notification-settings-page';
import users from './view/pages/users/users';

class App extends PureComponent {
  render() {
    return (
      <div className="app">
        <SnackBar />
        <LogoutAuth />
        <AppHeaderBar />
        <Grid container={true} className="content">
          <MenuDrawer />
          <div className="flexOne">
            <Switch>
              <Redirect exact={true} from="/" to="/devices" />
              <Route path="/devices" component={Devices}></Route>
              <Route path="/notification" component={notification}></Route>
              <Route path="/management" component={deviceManagementPage}></Route>
              <Route path="/teracomdevices" component={TeracomDevices}></Route>
              <Route path="/users" component={users}></Route>
              <Route path="/callback" component={Callback} />
            </Switch>
          </div>
          <NotificationDrawer />
          <NotificationDrawerApp />
        </Grid>
        <AppDrawer />
      </div>
    );
  }
}
export default App;
